// Fuente única de verdad para zonas geográficas.
// Si cambias una asignación, solo edita AQUÍ — MantenimientosView y ZonesView importan desde aquí.
// getDisponibilidad.js (backend) usa netlify/functions/_zonas.js, que es una copia CommonJS de este mismo dato.

export const ZONAS_POR_CP = {
  "0311": { zona: "Zona 4", tecnico: "Ivan"   },
  "0313": { zona: "Zona 4", tecnico: "Ivan"   },
  "0314": { zona: "Zona 4", tecnico: "Ivan"   },
  "0315": { zona: "Zona 4", tecnico: "Ivan"   },
  "0316": { zona: "Zona 4", tecnico: "Ivan"   },
  "0317": { zona: "Zona 4", tecnico: "Ivan"   }, // Ciudad Quesada (Rojales) y alrededores (San Fulgencio, Benijófar, Algorfa) — corregido de Zona 3 a Zona 4, 2026-09-15
  "0318": { zona: "Zona 3", tecnico: "Dani"   },
  "0319": { zona: "Zona 3", tecnico: "Dani"   },
  "0320": { zona: "Zona 4", tecnico: "Ivan"   },
  "0329": { zona: "Zona 4", tecnico: "Ivan"   },
  "0330": { zona: "Zona 4", tecnico: "Ivan"   },
  "0331": { zona: "Zona 4", tecnico: "Ivan"   },
  "0332": { zona: "Zona 4", tecnico: "Ivan"   },
  "0333": { zona: "Zona 4", tecnico: "Ivan"   },
  "0334": { zona: "Zona 4", tecnico: "Ivan"   },
  "0335": { zona: "Zona 4", tecnico: "Ivan"   },
  "0336": { zona: "Zona 4", tecnico: "Ivan"   },
  "0337": { zona: "Zona 4", tecnico: "Ivan"   },
  "0338": { zona: "Zona 4", tecnico: "Ivan"   },
  "0339": { zona: "Zona 4", tecnico: "Ivan"   },
  "3000": { zona: "Zona 5", tecnico: "Benito" },
  "3010": { zona: "Zona 5", tecnico: "Benito" },
  "3012": { zona: "Zona 5", tecnico: "Benito" },
  "3013": { zona: "Zona 5", tecnico: "Benito" },
  "3014": { zona: "Zona 5", tecnico: "Benito" },
  "3015": { zona: "Zona 5", tecnico: "Benito" },
  "3016": { zona: "Zona 5", tecnico: "Benito" },
  "3017": { zona: "Zona 5", tecnico: "Benito" },
  "3018": { zona: "Zona 5", tecnico: "Benito" },
  "3020": { zona: "Zona 1-2", tecnico: "Pablo" },
  "3030": { zona: "Zona 1-2", tecnico: "Pablo" },
  "3031": { zona: "Zona 1-2", tecnico: "Pablo" },
  "3032": { zona: "Zona 5", tecnico: "Benito" },
  "3033": { zona: "Zona 5", tecnico: "Benito" },
  "3035": { zona: "Zona 5", tecnico: "Benito" },
  "3036": { zona: "Zona 5", tecnico: "Benito" },
  "3037": { zona: "Zona 5", tecnico: "Benito" },
  "3038": { zona: "Zona 5", tecnico: "Benito" },
  "3039": { zona: "Zona 5", tecnico: "Benito" },
  "3042": { zona: "Zona 5", tecnico: "Benito" },
  "3050": { zona: "Zona 6", tecnico: "Benito" },
  "3053": { zona: "Zona 6", tecnico: "Benito" },
  "3055": { zona: "Zona 6", tecnico: "Benito" },
  "3056": { zona: "Zona 6", tecnico: "Benito" },
  "3057": { zona: "Zona 6", tecnico: "Benito" },
  "3058": { zona: "Zona 6", tecnico: "Benito" },
  "3059": { zona: "Zona 6", tecnico: "Benito" },
  "3060": { zona: "Zona 6", tecnico: "Benito" },
  "3061": { zona: "Zona 6", tecnico: "Benito" },
  "3062": { zona: "Zona 6", tecnico: "Benito" },
  "3064": { zona: "Zona 6", tecnico: "Benito" },
  "3070": { zona: "Zona 5", tecnico: "Benito" },
  "3071": { zona: "Zona 1-2", tecnico: "Pablo" },
  "3072": { zona: "Zona 1-2", tecnico: "Pablo" },
  "3073": { zona: "Zona 1-2", tecnico: "Pablo" },
  "3074": { zona: "Zona 1-2", tecnico: "Pablo" },
  "3080": { zona: "Zona 5", tecnico: "Benito" },
  "3081": { zona: "Zona 5", tecnico: "Benito" },
  "3082": { zona: "Zona 5", tecnico: "Benito" },
  "3083": { zona: "Zona 5", tecnico: "Benito" },
  "3084": { zona: "Zona 5", tecnico: "Benito" },
  "3085": { zona: "Zona 5", tecnico: "Benito" },
  "3086": { zona: "Zona 5", tecnico: "Benito" },
  "3087": { zona: "Zona 5", tecnico: "Benito" },
  "3088": { zona: "Zona 5", tecnico: "Benito" },
  "3089": { zona: "Zona 5", tecnico: "Benito" },
  "3112": { zona: "Zona 5", tecnico: "Benito" },
};

export function buscarZona(codigoPostal) {
  if (!codigoPostal || String(codigoPostal).length < 4) return null;
  return ZONAS_POR_CP[String(codigoPostal).slice(0, 4)] || null;
}
